import firebase from 'firebase';

const firebaseConfig = {
    apiKey: "AIzaSyDS6VBN4ovWPYueC6t3yTYC0-g0nDDCpHc",
    authDomain: "todo-app-10b11.firebaseapp.com",
    databaseURL: "https://todo-app-10b11.firebaseio.com",
    projectId: "todo-app-10b11",
    storageBucket: "todo-app-10b11.appspot.com",
    messagingSenderId: "708032244421",
    appId: "1:708032244421:web:37d65ce7c4556be41ddeac",
    measurementId: "G-E5VV8STE94"
  };
  
  const firebaseApp= firebase.initializeApp(firebaseConfig);
  const db= firebaseApp.firestore();

  export default db;